import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { LoadModel } from 'src/app/models/index';
import { CommonService, SiteService } from 'src/app/services/index';

@Component({
  selector: 'app-load-inventory',
  templateUrl: './load-inventory.component.html',
  styleUrls: ['./load-inventory.component.scss']
})
export class LoadInventoryComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayAllSiteID = false;
  selectedSite: string;
  loadSources: any;
  siteId: string;
  sites: any;
  loadData: any;
  displayedColumns = ['order', 'loadId', 'name', 'update'];
  constructor(
    private siteService: SiteService,
    private commonService: CommonService,
    private router: Router
  ) {}

  ngOnInit() {
    this.ngOnDestroy();
    this.getSiteDetails();
    if (localStorage.getItem('isMultipleSites') === 'false') {
      this.displayAllSiteID = false;
      this.selectedSite = localStorage.getItem('siteId');
      this.getLoadDetails();
    } else {
      this.displayAllSiteID = true;
      if (this.commonService.selectedSiteInLoadInventory !== '') {
        this.siteId = this.commonService.selectedSiteInLoadInventory;
        this.getLoadDetails();
      }
    }
  }
  ngOnDestroy() {
    this.commonService.selectedSiteInLoadInventory = '';
  }
  getSiteDetails() {
    this.siteService.getSiteDetails().subscribe((data) => {
      this.sites = data;
    });
  }
  getLoadDetails() {
    if (localStorage.getItem('isMultipleSites') === 'true') {
      this.selectedSite = this.siteId;
    }
    this.siteService.getLoadsBySiteId(this.selectedSite).subscribe((data) => {
      this.loadData = [];
      for (let i = 0; i < data.length; i++) {
        const model: LoadModel = data[i];
        model.order = i + 1;
        this.loadData.push(model);
      }
      this.loadSources = new MatTableDataSource<LoadModel>(this.loadData);
      this.loadSources.paginator = this.paginator;
    });
  }
  updateLoad(loadId) {
    this.router.navigate(['/add-load'], {
      queryParams: { loadId: loadId, siteId: this.siteId }
    });
    this.commonService.selectedSiteInLoadInventory = this.siteId;
  }
}
